import { IMPORT_PURCHASE_LISTING_TYPES } from './constants';

/**
 * Draft purchase listings on Finish (incomplete or ready to publish).
 * Tank services excluded.
 *
 * @param {object} listing
 */
export const isFinishTableListing = listing => {
  const state = listing?.attributes?.state;
  const listingType = listing?.attributes?.publicData?.listingType;
  return state === 'draft' && IMPORT_PURCHASE_LISTING_TYPES.includes(listingType);
};

export const hasFinishTableListings = listings =>
  Array.isArray(listings) && listings.some(isFinishTableListing);
